import React, { useEffect } from "react";
import DefaultAppBar from "../nav/AppBar";
import { Fab, useMediaQuery, useTheme } from "@mui/material";
import { Navigation as NavigationIcon } from "@mui/icons-material";
import { Text } from "../text/Text";
import { useStyle } from "@/context/StyleContext";
import VerticalDivider from "../VerticalDivider";

const ModalLayout = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { colors, theme: colorTheme } = useStyle();

  return (
    <div className="app-modal-layout">
      <div
        style={{
          maxWidth: "1440px",
          minHeight: "100vh",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            position: "fixed",
            margin: "0 auto",
            width: "100%",
            maxWidth: "1440px",
            backgroundColor: "transparent",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              height: "100vh",
              width: "100%",
            }}
          >
            <VerticalDivider />
            <VerticalDivider />
            <VerticalDivider />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ zIndex: 1 }}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalLayout;
